import { buildKeyframes } from './buildKeyframes';
import { ConvertBanner } from './exportBanner';
import { GetBannerSize } from './fileManager.js'
import { BackupDataBase } from './fileManager.js';
import CryptoJS from 'crypto-js'; 

export function CreateHash(banner) {
  var hash_string = `${Date.now()}_${banner.psd}_${banner.width}_${banner.height}`
  var hash = CryptoJS.MD5(hash_string).toString();
  return hash;
}

export async function BannerJson(banner, type) {
  let backup_image = "";
  try {
    backup_image = await BackupDataBase();
  } catch {}
  return {
    "key": banner.hash,
    "creative": type,
    "format": `${banner.width}x${banner.height}`,
    "file_title": banner.psd,
    "type": "master",
    "image_backup": backup_image
  }
}

export function BuildExtremeBanner(banner) {
  try {
    banner.preset = BuildPresetExtreme(banner);
    var timeline = BuildExtremeTimeline(banner.preset);
    var body = "";
    body += BuildBody(banner);
    body += GetPointAnimation(banner) + timeline;
    body += `
      //#TIMELINE#
      if (count > 0) {
        timeline.animationElements("LOOPING", [
          [".banner", 4]
        ], function () {
            animabanner()
          });
      }
    }
    
    var count = ${banner.loop};
  
    animabanner();
    </script>`;
    body.replace("#{count}#", banner.loop);
    banner.body = body;
    banner.animation = buildKeyframes(banner);
    banner.html = ConvertBanner(banner, true);
    banner.duration = GetBannerTime(banner.elements);
    banner.timeline = banner.preset;
    banner.bannerBorder = banner.bannerBorder !== undefined ? banner.bannerBorder : 'solid 0.75px  #aeaeae';
    banner.backgroundColor = banner.backgroundColor !== undefined  ? banner.backgroundColor : '#fff';
    return banner;
  } catch(error) { }
}

export function GetCustomKeyframe(customsKeyframe, animationName) {
  try {
    for (var i = 0; i < customsKeyframe.length; i++) {
      if (customsKeyframe[i].animation === animationName) {
        return customsKeyframe[i];
      }
    }
    return null;
  } catch {}
}

export function BuildPresetExtreme(banner) {
  try {
    const presetExtreme = [];
    const steps = banner.elements[banner.elements.length - 1].step;
    for (var i = 1; i <= steps; i++) {
      let aux = i;
      const elements = banner.elements.filter(el => el.step === aux);
      for (var j = 0; j < elements.length; j++) {
        const element = elements[j];
        const custom = element.animation.in.customKeyframe
          ? GetCustomKeyframe(banner.customKeyframe, element.animation.in.animation) : null;
        var delay = element.animation.in.delay;
        var duration = element.animation.in.duration;
        var animation = custom ? custom.animation : element.animation.in.animation;
        var direction = element.animation.in.direction;
        presetExtreme.push({
          name: element.id,
          delay: delay,
          animation: animation,
          direction: direction,
          duration: duration,
          type: "IN",
          step: element.step,
          parent: element.parent,
          children: element.children,
          loop: element.loop,
          customKeyframe: custom
        });
      }

      if (aux < steps) {
        const elementsOut = banner.elements.filter(el => el.stepout === aux + 1);
        for (j = 0; j < elementsOut.length; j++) {
          if (!elementsOut[j].fixo) {
            try {
              const element = elementsOut[j];
              const custom =
                element.animation.out.customKeyframe
                ? GetCustomKeyframe(banner.customKeyframe, element.animation.out.animation) : null;
              delay = element.animation.out.delay;
              duration = element.animation.out.duration;
              animation = custom ? custom.animation : element.animation.out.animation;
              direction = element.animation.out.direction;
              presetExtreme.push({
                name: element.id,
                delay: delay,
                animation: animation,
                direction: direction,
                duration: duration,
                type: "OUT",
                step: element.step,
                parent: element.parent,
                children: element.children,
                loop: element.loop,
                customKeyframe: custom
              });
            } catch (error) {}
          }
        }
      }
    }
    return presetExtreme;
  } catch(error) { }
}

export function BuildExtremeTimeline(preset) {
  var timeline = "";
  var timeline2 = "";
  var count = 2;
  var childrens = false;
  preset.forEach(item => {
    childrens = false;
    if (!item.parent) {
      var animationName = "";
      if (item.customKeyframe) {
        animationName = item.animation;
      } else {
        animationName = `${item.animation}_${item.direction}_${item.duration}_${item.type.toUpperCase()}`;
        animationName += item.loop > 1 ? `_iteration_${item.loop}` : item.loop === -1 ? `_iteration_infinite` : "";
      }
      timeline += `timeline.animationElements("${animationName}", [
        [".${item.name}", ${item.delay}]//,${item.type.toUpperCase()}
      ]);`
      timeline2 = `var timeline_${count} = new Point_Animation();
      timeline.animationElements("STOP_HERE", [
        [".${item.name}", 0]//,${item.type.toUpperCase()}
      ], function() {`;
      preset.forEach(children => {
        if (children.parent === item.name && children.type.toUpperCase() === "IN") {
          childrens = true;
          if (children.customKeyframe) {
            animationName = children.animation;
          } else {
            animationName = `${children.animation}_${children.direction}_${children.duration}_${children.type.toUpperCase()}`;
            animationName += children.loop > 1 ? `_iteration_${children.loop}` : children.loop === -1 ? `_iteration_infinite` : "";
          }
          timeline2 += `timeline_${count}.animationElements("${animationName}", [
            [".${children.name}", ${children.delay}]//,${item.type.toUpperCase()}
          ]);`
        }
      });
      timeline2 += "});";
      if (childrens) {
        timeline += timeline2;
        count++;
      } else {
        timeline2 = "";
      }
    }
  });
  return timeline;
}

export function BuildBody(banner) {
  var body = `<body>`;
  body += banner.audio && banner.audio.b64 ? `
    <audio id="player">
      <source src="data:audio/${banner.audio.ext};${banner.audio.b64}" type="audio/${banner.audio.ext}">
    </audio>
    <div id='click-sound'>
      <svg style="cursor: pointer;fill: ${banner.audio.bg ? 'black' : 'white'};display: none;width: 15px;position: absolute;top: 10px;${banner.audio.direction}: 10px;z-index: 999;" version="1.1" id="sound-on" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 122.88 94.98" style="enable-background:new 0 0 122.88 94.98" xml:space="preserve"><style type="text/css">.st0{fill-rule:evenodd;clip-rule:evenodd;}</style><g><path class="st0" d="M5.06,20.78h20.67c0.43,0,0.79,0.35,0.79,0.79v44.72c0,0.43-0.35,0.79-0.79,0.79H5.05 C2.27,67.07,0,64.8,0,62.02V25.85C0,23.06,2.28,20.78,5.06,20.78L5.06,20.78z M109.14,1.06c5.01,7.08,8.82,15.04,11.14,23.57 c2.24,8.22,3.1,16.97,2.33,25.94c-0.7,8.2-2.7,15.99-5.79,23.18c-2.59,6.03-5.95,11.64-9.93,16.7c-0.62,0.82-1.25,1.63-1.9,2.43 l-0.05-0.05c-0.31,0.36-0.62,0.72-0.94,1.07l-0.94,1.06l-0.92-1.08l-3.73-4.38l-0.69-0.81l0.7-0.8c4.54-5.23,8.3-11.2,11.06-17.73 c2.66-6.29,4.39-13.11,4.99-20.29c0.68-7.98-0.08-15.75-2.06-23.05c-1.83-6.75-4.7-13.11-8.44-18.86l-0.02-0.02 c-0.68-0.99-1.39-1.97-2.13-2.92l0.08-0.07l-0.05-0.07l0.97-0.72l0.71-0.53l2.71-2.19l0.09,0.12l1.05-0.78l1.02-0.76L109.14,1.06 L109.14,1.06z M108.58,4.66c-0.25-0.38-0.49-0.75-0.75-1.12l-0.03,0.02C108.07,3.92,108.33,4.29,108.58,4.66L108.58,4.66z M92.75,12.19c3.68,5.28,6.47,11.21,8.17,17.55c1.64,6.12,2.26,12.61,1.7,19.27c-0.48,5.68-1.8,11.11-3.83,16.17 c-2.1,5.23-4.95,10.05-8.4,14.32l-0.94,1.16l-0.97-1.14l-4.72-3.29l-0.66-0.77l0.62-0.8c2.91-3.72,6.01-7.87,7.77-12.35 c1.7-4.33,2.1-8.99,2.51-13.88c0.5-5.86-0.04-11.55-1.47-16.9c-1.34-5.04-3.48-9.8-6.27-14.11c-0.37-0.53-0.75-1.06-1.15-1.58 l0.05-0.04l-0.46-0.66l0.96-0.71L91,11.9l1.03-0.76L92.75,12.19L92.75,12.19z M89.84,15.13l-0.31-0.47l-0.02,0.01L89.84,15.13 L89.84,15.13z M31,19.96C43.04,13.35,55.09,6.74,67.13,0.14c1.16-0.63,2.4,1.08,2.4,2.4v82.04c0,1.39-1.32,3.21-2.53,2.53L31,66.8 c-0.23-0.13-0.48-0.21-0.48-0.48V20.44C30.52,20.17,30.77,20.09,31,19.96L31,19.96z"/></g></svg>
    </div>`: ""
  body += banner.audioIA && banner.audioIA.b64 ? `
    <audio id="player-IA">
      <source src="data:audio/${banner.audioIA.ext};${banner.audioIA.b64}" type="audio/${banner.audioIA.ext}">
    </audio>` : "" 
  body += banner.audio && banner.audio.b64 ?
    `<div id='click-sound'>
      <svg style="cursor: pointer;fill: ${banner.audio.bg ? 'black' : 'white'};display: none;width: 15px;position: absolute;top: 10px;${banner.audio.direction}: 10px;z-index: 999;" version="1.1" id="sound-on" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 122.88 94.98" style="enable-background:new 0 0 122.88 94.98" xml:space="preserve"><style type="text/css">.st0{fill-rule:evenodd;clip-rule:evenodd;}</style><g><path class="st0" d="M5.06,20.78h20.67c0.43,0,0.79,0.35,0.79,0.79v44.72c0,0.43-0.35,0.79-0.79,0.79H5.05 C2.27,67.07,0,64.8,0,62.02V25.85C0,23.06,2.28,20.78,5.06,20.78L5.06,20.78z M109.14,1.06c5.01,7.08,8.82,15.04,11.14,23.57 c2.24,8.22,3.1,16.97,2.33,25.94c-0.7,8.2-2.7,15.99-5.79,23.18c-2.59,6.03-5.95,11.64-9.93,16.7c-0.62,0.82-1.25,1.63-1.9,2.43 l-0.05-0.05c-0.31,0.36-0.62,0.72-0.94,1.07l-0.94,1.06l-0.92-1.08l-3.73-4.38l-0.69-0.81l0.7-0.8c4.54-5.23,8.3-11.2,11.06-17.73 c2.66-6.29,4.39-13.11,4.99-20.29c0.68-7.98-0.08-15.75-2.06-23.05c-1.83-6.75-4.7-13.11-8.44-18.86l-0.02-0.02 c-0.68-0.99-1.39-1.97-2.13-2.92l0.08-0.07l-0.05-0.07l0.97-0.72l0.71-0.53l2.71-2.19l0.09,0.12l1.05-0.78l1.02-0.76L109.14,1.06 L109.14,1.06z M108.58,4.66c-0.25-0.38-0.49-0.75-0.75-1.12l-0.03,0.02C108.07,3.92,108.33,4.29,108.58,4.66L108.58,4.66z M92.75,12.19c3.68,5.28,6.47,11.21,8.17,17.55c1.64,6.12,2.26,12.61,1.7,19.27c-0.48,5.68-1.8,11.11-3.83,16.17 c-2.1,5.23-4.95,10.05-8.4,14.32l-0.94,1.16l-0.97-1.14l-4.72-3.29l-0.66-0.77l0.62-0.8c2.91-3.72,6.01-7.87,7.77-12.35 c1.7-4.33,2.1-8.99,2.51-13.88c0.5-5.86-0.04-11.55-1.47-16.9c-1.34-5.04-3.48-9.8-6.27-14.11c-0.37-0.53-0.75-1.06-1.15-1.58 l0.05-0.04l-0.46-0.66l0.96-0.71L91,11.9l1.03-0.76L92.75,12.19L92.75,12.19z M89.84,15.13l-0.31-0.47l-0.02,0.01L89.84,15.13 L89.84,15.13z M31,19.96C43.04,13.35,55.09,6.74,67.13,0.14c1.16-0.63,2.4,1.08,2.4,2.4v82.04c0,1.39-1.32,3.21-2.53,2.53L31,66.8 c-0.23-0.13-0.48-0.21-0.48-0.48V20.44C30.52,20.17,30.77,20.09,31,19.96L31,19.96z"/></g></svg>
    </div>  
    <svg style="cursor: pointer;fill: ${banner.audio.bg ? 'black' : 'white'};display: block;width: 15px;position: absolute;top: 10px;${banner.audio.direction}: 10px;z-index: 999;" id="sound-off" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 122.88 96"><title>volume-mute</title><path d="M12.81,22.46H38.34L59.46,1.18a4,4,0,0,1,5.66,0A3.91,3.91,0,0,1,66.31,4h0V92a4,4,0,0,1-6.9,2.81l-20.87-17H12.81A12.84,12.84,0,0,1,0,65V35.27A12.84,12.84,0,0,1,12.81,22.46Zm100.62,8.09a5.48,5.48,0,0,1,7.82,0,5.62,5.62,0,0,1,0,7.89L111.83,48l9.45,9.59a5.57,5.57,0,0,1-.06,7.85,5.49,5.49,0,0,1-7.79,0L104,55.9l-9.4,9.55a5.5,5.5,0,0,1-7.82,0,5.63,5.63,0,0,1,0-7.9L96.23,48,86.78,38.4a5.56,5.56,0,0,1,.06-7.84,5.47,5.47,0,0,1,7.79,0l9.4,9.52,9.4-9.54Z"/></svg>
    ` :
    banner.audioIA && banner.audioIA.b64 ?    
    `<div id='click-sound'>
      <svg style="cursor: pointer;fill: ${banner.audioIA.bg ? 'black' : 'white'};display: none;width: 15px;position: absolute;top: 10px;${banner.audioIA.direction}: 10px;z-index: 999;" version="1.1" id="sound-on" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 122.88 94.98" style="enable-background:new 0 0 122.88 94.98" xml:space="preserve"><style type="text/css">.st0{fill-rule:evenodd;clip-rule:evenodd;}</style><g><path class="st0" d="M5.06,20.78h20.67c0.43,0,0.79,0.35,0.79,0.79v44.72c0,0.43-0.35,0.79-0.79,0.79H5.05 C2.27,67.07,0,64.8,0,62.02V25.85C0,23.06,2.28,20.78,5.06,20.78L5.06,20.78z M109.14,1.06c5.01,7.08,8.82,15.04,11.14,23.57 c2.24,8.22,3.1,16.97,2.33,25.94c-0.7,8.2-2.7,15.99-5.79,23.18c-2.59,6.03-5.95,11.64-9.93,16.7c-0.62,0.82-1.25,1.63-1.9,2.43 l-0.05-0.05c-0.31,0.36-0.62,0.72-0.94,1.07l-0.94,1.06l-0.92-1.08l-3.73-4.38l-0.69-0.81l0.7-0.8c4.54-5.23,8.3-11.2,11.06-17.73 c2.66-6.29,4.39-13.11,4.99-20.29c0.68-7.98-0.08-15.75-2.06-23.05c-1.83-6.75-4.7-13.11-8.44-18.86l-0.02-0.02 c-0.68-0.99-1.39-1.97-2.13-2.92l0.08-0.07l-0.05-0.07l0.97-0.72l0.71-0.53l2.71-2.19l0.09,0.12l1.05-0.78l1.02-0.76L109.14,1.06 L109.14,1.06z M108.58,4.66c-0.25-0.38-0.49-0.75-0.75-1.12l-0.03,0.02C108.07,3.92,108.33,4.29,108.58,4.66L108.58,4.66z M92.75,12.19c3.68,5.28,6.47,11.21,8.17,17.55c1.64,6.12,2.26,12.61,1.7,19.27c-0.48,5.68-1.8,11.11-3.83,16.17 c-2.1,5.23-4.95,10.05-8.4,14.32l-0.94,1.16l-0.97-1.14l-4.72-3.29l-0.66-0.77l0.62-0.8c2.91-3.72,6.01-7.87,7.77-12.35 c1.7-4.33,2.1-8.99,2.51-13.88c0.5-5.86-0.04-11.55-1.47-16.9c-1.34-5.04-3.48-9.8-6.27-14.11c-0.37-0.53-0.75-1.06-1.15-1.58 l0.05-0.04l-0.46-0.66l0.96-0.71L91,11.9l1.03-0.76L92.75,12.19L92.75,12.19z M89.84,15.13l-0.31-0.47l-0.02,0.01L89.84,15.13 L89.84,15.13z M31,19.96C43.04,13.35,55.09,6.74,67.13,0.14c1.16-0.63,2.4,1.08,2.4,2.4v82.04c0,1.39-1.32,3.21-2.53,2.53L31,66.8 c-0.23-0.13-0.48-0.21-0.48-0.48V20.44C30.52,20.17,30.77,20.09,31,19.96L31,19.96z"/></g></svg>
    </div>  
    <svg style="cursor: pointer;fill: ${banner.audioIA.bg ? 'black' : 'white'};display: block;width: 15px;position: absolute;top: 10px;${banner.audioIA.direction}: 10px;z-index: 999;" id="sound-off" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 122.88 96"><title>volume-mute</title><path d="M12.81,22.46H38.34L59.46,1.18a4,4,0,0,1,5.66,0A3.91,3.91,0,0,1,66.31,4h0V92a4,4,0,0,1-6.9,2.81l-20.87-17H12.81A12.84,12.84,0,0,1,0,65V35.27A12.84,12.84,0,0,1,12.81,22.46Zm100.62,8.09a5.48,5.48,0,0,1,7.82,0,5.62,5.62,0,0,1,0,7.89L111.83,48l9.45,9.59a5.57,5.57,0,0,1-.06,7.85,5.49,5.49,0,0,1-7.79,0L104,55.9l-9.4,9.55a5.5,5.5,0,0,1-7.82,0,5.63,5.63,0,0,1,0-7.9L96.23,48,86.78,38.4a5.56,5.56,0,0,1,.06-7.84,5.47,5.47,0,0,1,7.79,0l9.4,9.52,9.4-9.54Z"/></svg>
    ` : ""  
    ;

  body += `<a href="javascript:window.open(window.clickTag)"><div id="banner" class="banner">`;
  banner.elements.forEach(element => {
    if (element.step > 0 && element.parent === null) {
      if (element.properties.type === "video") {
        body += `<div id="${element.id}" class="${element.id}" style="position: relative;overflow: hidden;">`;
        body += `<video id="${element.id}-video" class="${element.id}-video" autoplay loop muted playsinline style="width: 100%; height: 100%; object-fit: cover;">`;
        body += `<source src="data:video/mp4;${element.properties.background}" type="video/mp4">`;
        body += `</video>`;
      } else {
        body += `<div id="${element.id}" class="${element.id}">`;
      }
      if (element.children) {
        banner.elements.forEach(children => {
          if (children.parent === element.id) {
            body += `<div id="${children.id}" class="${children.id}"></div>`;
          }
        });
      } else if (element.id.toLowerCase().includes("txt")) {
        element.category = "txt";
      } else if (element.id.toLowerCase().includes("bg")) {
        element.category = "bg";
      } else if (element.id.toLowerCase().includes("imga")) {
        element.category = "imgA";
      } else if (element.id.toLowerCase().includes("imgb")) {
        element.category = "imgB";
      } else if (element.id.toLowerCase().includes("imgc")) {
        element.category = "imgC";
      } else if (element.id.toLowerCase().includes("imgd")) {
        element.category = "imgD";
      } else element.category = "";
      body += `</div>`;
    }
  });
  body += `</div>`;
  body += "</a></body>";
  return body;
}


function GetBannerTime(elements) {
  var time = 0.0;
  const step = elements[elements.length - 1].step;
  elements.forEach(element => {
    try {
      const delay = parseFloat(element.animation.in.delay);
      if (delay > 0) time += delay;
    } catch {}
    try {
      if (element.step !== step && !element.fixo) {
        const delay = parseFloat(element.animation.out.delay);
        if (delay > 0) time += delay;
      }
    } catch {}
  });

  const lastAnimation = elements[elements.length - 1].animation.in.duration ? parseInt(elements[elements.length - 1].animation.in.duration) / 1000 : 2;
  return parseFloat(time.toFixed(1)) + lastAnimation;
}

export function GetPointAnimation(banner) {
  let script = `<script type="text/javascript">`
  script += banner.audio && banner.audio.b64 ? `
      document.getElementById("sound-on").addEventListener("click", stopAudio);
      document.getElementById("sound-off").addEventListener("click", playAudio);
      var audioTag = document.getElementById("player");

      var cron = 0
      var tempo = 0;
      var delay = ${banner.audio.delay}
      
      function start() {
        pause();
        cron = setInterval(() => {
          timer();
        }, 10);
      }

      function pause() {
        clearInterval(cron);
      }

      function timer() {
        if (tempo / 1000 - delay * 1000 >= audioTag.duration) return;        
        if (tempo < delay * 1000) audioTag.currentTime = 0;
        tempo += 10;
      }
      start();

      function playAudio() {
        console.log('playAudio')
        document.getElementById("sound-on").style.display = 'block';
        document.getElementById("sound-off").style.display = 'none';
        if (tempo / 1000 >= audioTag.duration) return;
        audioTag.currentTime = tempo / 1000;
        audioTag.play();
      }
      
      function stopAudio() {
        audioTag.pause();
        document.getElementById("sound-on").style.display = 'none';
        document.getElementById("sound-off").style.display = 'block';
      }
  ` : ``

  script += banner.audioIA && banner.audioIA.b64 ? `
      document.getElementById("sound-on").addEventListener("click", stopAudioIA);
      document.getElementById("sound-off").addEventListener("click", playAudioIA);
      var audioTagIA = document.getElementById("player-IA");

      var cronIA = 0
      var tempoIA = 0;
      var delayIA = ${banner.audioIA.delay}
      
      function startIA() {
        pauseIA();
        cronIA = setInterval(() => {
          timerIA();
        }, 10);
      }

      function pauseIA() {
        clearInterval(cronIA);
      }

      function timerIA() {
        if (tempoIA / 1000 - delayIA * 1000 >= audioTagIA.duration) return;        
        if (tempoIA < delayIA * 1000) audioTagIA.currentTime = 0;
        tempoIA += 10;
      }
      startIA();

      function playAudioIA() {
        console.log('playAudio')
        document.getElementById("sound-on").style.display = 'block';
        document.getElementById("sound-off").style.display = 'none';
        if (tempoIA / 1000 >= audioTagIA.duration) return;
        audioTagIA.currentTime = tempoIA / 1000;
        audioTagIA.play();
      }
      
      function stopAudioIA() {
        audioTagIA.pause();
        document.getElementById("sound-on").style.display = 'none';
        document.getElementById("sound-off").style.display = 'block';
      }
  ` : ``

  
  // script += banner.audio || banner.audioIA ? `
  //   function startAudio() {
  //     try {
  //       playAudio();
  //     } catch {}
  //     try {
  //       playAudioIA();
  //     } catch {}
  //   }
    
  //   function pauseAudio() {
  //     try {
  //       stopAudio();
  //     } catch {}
  //     try {
  //       stopAudioIA();
  //     } catch {}
  //   }
  // ` : '';


  script += `
    var d = document;
    var el = function (e) {
        return d.querySelector(e)
    }

    function Point_Animation() {
        var e, t = 0,
            n = [],
            i = document.createElement("div");

        function o(e) {
            if (".all" == e) {
                t = 0;
                for (var i = 0; i < n.length; i++) {
                    for (var o = document.querySelectorAll("." + n[i][0]), r = 0; r < o.length; r++) o[r]
                        .classList.remove(n[i][1]);
                    clearTimeout(n[i][2])
                }
            } else
                for (var l = 0; l < n.length; l++)
                    if (n[l][0] == e.replace(".", "")) {
                        var a = document.querySelectorAll("." + n[l][0]);
                        for (r = 0; r < a.length; r++) a[r].classList.remove(n[l][1])
                    }
        }
        i.setAttribute("style",
                "margin:2px;width:95px;height:auto;background-color:#000000;color:white;z-index:9999;position:relative;text-align:center;top:0px;left:0px;opacity: 0.5;border-radius: 10px;font-size: 10px;line-height: 50px;"
            ), i.innerHTML = "<span>DEBUG:</span>", i.querySelector("span").setAttribute("style",
                "position: absolute;font-size: 9px;color: #fff;top: -16px;left: 31px;"), this
            .animationElements = function (r, l, a) {
                for (var s = 0, c = 0; c < l.length; c++) document.querySelector(l[c][0]) ? (t += 1e3 * l[c]
                    [1], e = l[c][0].replace(".", ""), window["timer" + c] = t, window["clear_" + e] =
                    setTimeout((function () {
                        if ("STOP_HERE" == r && a && a(), "LOOPING" == r) o(".all"), a && a();
                        else
                            for (var e = s; e == s; s++) {
                                window["elementMoment" + e] = l[e][0];
                                for (var t = document.querySelectorAll(window["elementMoment" +
                                        e]), n = 0; n < t.length; n++) t[n].classList.add(r)
                            }
                    }), window["timer" + c]), n.push([e, r, window["clear_" + e]])) : (i.innerHTML = i
                    .innerHTML + l[c][0] + ": error<br>", document.body.appendChild(i))
            }, this.animationControlTime = function (e) {
                var t = 1,
                    n = document.createElement("div");
                n.setAttribute("style",
                        "width:95px;height:40px;background-color:#B50707;color:white;z-index:9999;position:relative;text-align:center;top:0px;left:0px;opacity: 0.5;border-radius: 50px;font-size: 22px;line-height: 50px;"
                    ), n.innerHTML = "<span>Timer animation:</span>", n.querySelector("span")
                    .setAttribute("style",
                        "position: absolute;font-size: 9px;color: #fff;top: -16px;left: 9px;"), document
                    .body.appendChild(n);
                var i = setInterval((function () {
                    var o, r = t.toString();
                    1 == r.length ? o = "0." + r.substr(0, 1) : 2 == r.length ? o = r.substr(0,
                            1) + "." + r.substr(1, 1) : 3 == r.length && (o = r.substr(0, 1) + r
                            .substr(1, 1) + "." + r.substr(2, 1)), n.innerHTML = o +
                        "<span>Timer animation:</span>s", n.querySelector("span").setAttribute(
                            "style",
                            "position: absolute;font-size: 9px;color: #fff;top: -16px;left: 9px;"
                        ), t++, el(e).addEventListener("transitionend", (function (e) {
                            clearInterval(i)
                        }), !1), el(e).addEventListener("webkitTransitionEnd", (function (e) {
                            clearInterval(i)
                        }), !1), el(e).addEventListener("oTransitionEnd", (function (e) {
                            clearInterval(i)
                        }), !1), el(e).addEventListener("animationend", (function (e) {
                            clearInterval(i)
                        }), !1), el(e).addEventListener("webkitAnimationEnd", (function (e) {
                            clearInterval(i)
                        }), !1), el(e).addEventListener("MSAnimationEnd", (function (e) {
                            clearInterval(i)
                        }), !1)
                }), 100)
            }, this.clearAnimation = o
    }
    var timeline = new Point_Animation();
    //#DURATION:${banner.duration}#
    
    //
    /*[dynamic_content]*/
    //
    
    function animabanner() {
      count--;
      //#TIMELINE#
      timeline.animationElements("cortina_out", [
          [".banner", 0]
      ]);`;
  return script;
}